import { Helmet } from 'react-helmet';

import { AppRoutes } from '@/components/app/routes';
import WxCopilotHost from '@/components/pages/wx-copilot-host';
import { AccessDenied } from '@/components/ui/access-denied';
import { ErrorStateFallback } from '@/components/ui/error-state';
import { Spinner } from '@/components/ui/spinner';
import { useAuthContext } from '@/contexts/auth-context';
import { domainMeta } from '@/utils/domain-meta';
import { fullstorySnippetString } from '@/utils/fullstory';

const SIGNIN_URL = `${domainMeta.monolithOrigin}/users/sign_in?redirect=source`;

export function App() {
  const { isAuthenticated, isLoading, hasSourceAccess } = useAuthContext();

  if (isLoading) return <Spinner />;

  if (!isAuthenticated) {
    window.location.href = SIGNIN_URL;
    return <Spinner />;
  }

  if (!hasSourceAccess) return <AccessDenied />;

  return (
    <ErrorStateFallback>
      <Helmet>
        <script>{fullstorySnippetString}</script>
      </Helmet>
      <WxCopilotHost />
      <AppRoutes />
    </ErrorStateFallback>
  );
}
